module.exports = __webpack_public_path__ + "img/Featured Content Block.f701a936.png";